import createAxiosClient, {
	createOverriddenDateInterceptor
} from "./util/createAxiosInstance"
import type { AxiosInstance } from "axios"
import { AutomationClient } from "./Automation.Client"
import { AuditQueryClient } from "./Audit.Client"
import { EnvironmentClient } from "./Environment.Client"
import { TemplateQueryClient } from "./Template.Client"
import { SsoQueryClient } from "./Sso.Client"
import { ExtractsClient } from "./Extracts.Client"
import { BridgeQueryClient } from "./Bridge.Client"
import { IntegrationsClient } from "./IntegrationsClient"
import { ImportClient } from "./Import.Client"
import { PatientClient } from "./Patient.Client"
import { MedicalHierarchyClient } from "./MedicalHierarchy.Client"
import { EventLogClient } from "./EventLog.Client"
import ProfessionalClient from "./Professional.Client"
import UserClient from "./User.Client"

export class ApiClient {
	private axiosClient: AxiosInstance

	constructor() {
		this.axiosClient = createAxiosClient()

		this.automation = new AutomationClient(this.axiosClient)
		this.audit = new AuditQueryClient(this.axiosClient)
		this.bridge = new BridgeQueryClient(this.axiosClient)
		this.environment = new EnvironmentClient(this.axiosClient)
		this.eventLog = new EventLogClient(this.axiosClient)
		this.extracts = new ExtractsClient(this.axiosClient)
		this.medicalHierarchy = new MedicalHierarchyClient(this.axiosClient)
		this.import = new ImportClient(this.axiosClient)
		this.integration = new IntegrationsClient(this.axiosClient)
		this.patient = new PatientClient(this.axiosClient)
		this.professional = new ProfessionalClient(this.axiosClient)
		this.sso = new SsoQueryClient(this.axiosClient)
		this.template = new TemplateQueryClient(this.axiosClient)
		this.user = new UserClient(this.axiosClient)
	}

	public automation: AutomationClient
	public audit: AuditQueryClient
	public bridge: BridgeQueryClient
	public environment: EnvironmentClient
	public eventLog: EventLogClient
	public extracts: ExtractsClient
	public medicalHierarchy: MedicalHierarchyClient
	public import: ImportClient
	public integration: IntegrationsClient
	public patient: PatientClient
	public professional: ProfessionalClient
	public sso: SsoQueryClient
	public template: TemplateQueryClient
	public user: UserClient

	public applyOverriddenDateInterceptor = (
		overriddenDateProvider: () => string | undefined
	) => {
		this.axiosClient.interceptors.request.use(
			createOverriddenDateInterceptor(overriddenDateProvider)
		)
	}
}

const apiClient = new ApiClient()

export default apiClient
